import { SupportPage } from '@/pages/Support';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/support/')({
  component: SupportPage,
  loader: () => ({ crumb: 'Support' }),
});
